// removed by extract-text-webpack-plugin
module.exports = {"root":"js-components-CourseDetails-CourseDetails-module__root--3y2cJ","expires":"js-components-CourseDetails-CourseDetails-module__expires--bxziN"};